// extracted by mini-css-extract-plugin
export var actions = "_1b-0";
export var actionsContainer = "_1b-6";
export var border = "_1b-1";
export var childFullHeight = "_1b-d";
export var collapse = "_1b-2";
export var content = "_1b-8";
export var contentChild = "_1b-c";
export var fullscreen = "_1b-a";
export var hasLeftRadius = "_1b-i";
export var headerContainer = "_1b-3";
export var headerRow = "_1b-5";
export var hidePadding = "_1b-9";
export var navCollapsedGap = "_1b-j";
export var noScrollX = "_1b-k";
export var noScrollY = "_1b-l";
export var noTopPadding = "_1b-g";
export var optOutTopPadding = "_1b-b";
export var pageMain = "_1b-h";
export var pageOuter = "_1b-e";
export var pagePadding = "_1b-7";
export var profile = "_1b-m";
export var profileContainer = "_1b-n";
export var profileImage = "_1b-o";
export var profileMain = "_1b-p";
export var profileSubtitle = "_1b-r";
export var profileTitle = "_1b-q";
export var showLeftPadding = "_1b-f";
export var tabsWrapper = "_1b-4";
export var title = "_1b-s";